<template>
  <div id="GoTop" @click="GoTop()" v-show="showGoTop">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false,
      topScroll: 0,
      showGoTop: false, // 控制按钮显示状态
      scrollThreshold: 300 // 滚动阈值，超过300px显示按钮
    };
  },
  mounted() {
    // 组件挂载后添加滚动事件监听器
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    // 组件销毁前移除滚动事件监听器，避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 处理滚动事件的方法
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 当滚动高度超过阈值时显示按钮，否则隐藏
      this.showGoTop = scrollTop > this.scrollThreshold;
    },

    GoTop() {
      const scrollToTop = () => {
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          const newScroll = Math.max(0, currentScroll - Math.max(currentScroll / 10, 1));
          this.topScroll = newScroll;
          console.log(newScroll);

          window.scrollTo(0, newScroll);
          if (newScroll > 0) {
            window.requestAnimationFrame(scrollToTop);
          }
        }
      };
      scrollToTop();
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
  /* 添加过渡动画，使按钮显示/隐藏更平滑 */
  transition: opacity 0.3s ease-in-out;
}

#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue